import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';


import {HttpClient, HttpParams} from '@angular/common/http';
import {BaseRestService} from '../common/BaseRestService';
import {OrganizationPolicyDocumentResponse} from '../../types/organization/organization-policy-document-response';
import {PolicyDocumentType} from '../../types/organization/policy-document-type';

@Injectable()
export class OrganizationPolicyDocumentsRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('policy-documents');
  }

  getAllPolicyDocuments(): Observable<OrganizationPolicyDocumentResponse> {
    return this.http.get<OrganizationPolicyDocumentResponse>(this.getEndpoint(['search']));
  }

  search(name: string): Observable<PolicyDocumentType[]> {
    const params = {
      params: new HttpParams()
        .set('name', name)
    };

    return this.http.get<PolicyDocumentType[]>(this.getEndpoint(['search']), params);
  }

  create(policyDocument): Observable<any> {
    return this.http.post(this.getEndpoint(), policyDocument);
  }

  update(policyDocument): Observable<any> {
    return this.http.put(this.getEndpoint([String(policyDocument.id)]), policyDocument);
  }

  delete(policyDocument): Observable<any> {
    return this.http.delete(this.getEndpoint([String(policyDocument.id)]));
  }

}
